import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, FormControl, TextField } from '@mui/material';
import DetalleCoberturaOrdenData from './components/DetalleCoberturaOrdenData';

const VerificarCostoOrdenView = ({ data, open, onClose, ...props }) => {
  const { practicas, totales } = data;

  if (!data) {
    return null;
  }

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div>
      <Dialog
        maxWidth='lg'
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{'Verificar Costo Orden de Prestación'}</DialogTitle>
        <DialogContent>
          {practicas && (
            <FormControl fullWidth={true} variant='outlined' margin='normal'>
              <TextField
                id='practica'
                variant='standard'
                label='Práctica'
                defaultValue={
                  practicas &&
                  Object.values(practicas).map(
                    (practica) => `(${practica.codigoPractica}) ${practica.descripcionPractica}`,
                  )
                }
                size='small'
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>
          )}
          {totales && (
            <FormControl fullWidth={true} variant='outlined' margin='normal'>
              <TextField
                id='coseguro'
                variant='standard'
                label='Coseguro a pagar al Prestador'
                defaultValue={`$ ${totales?.totalPagar || 0.0}`}
                size='small'
                fullWidth
                InputProps={{
                  readOnly: true,
                  style: { fontWeight: 'bold' },
                }}
              />
            </FormControl>
          )}
          {practicas && <DetalleCoberturaOrdenData detallePracticas={practicas} />}
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleClose} variant='contained' color='neutral' autoFocus>
            Salir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VerificarCostoOrdenView;
